// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__HVMcQ","tab":"Tabs_tab__1sq6R","tabActive":"Tabs_tabActive__1gdaY"};